<template>
    <div class="OnboardingStep g-pt-8">
        <div :v-if="image" class="g-mb-7" style="text-align: center">
            <img :src="image" width="160px" />
        </div>

        <g-row class="g-mb-7">
            <g-column :span="24" class="g-mb-3">
                <g-typography tag="h2" size="h1" font-weight="semibold" text-align="center">
                    {{ title }}
                </g-typography>
            </g-column>

            <g-column :span="24">
                <g-typography tag="p" text-align="center" color="grey-6">
                    {{ message }}
                </g-typography>
            </g-column>
        </g-row>

        <g-row type="flex" align="middle" justify="space-around" class="g-mb-3">
            <g-column :xs="24" :sm="16">
                <g-steps :current="showStep" direction="vertical">
                    <g-step
                        v-for="(step, i) in onboardingSteps"
                        :key="i"
                        :title="step.title"
                        :description="step.description"
                    />
                </g-steps>
            </g-column>
        </g-row>

        <g-row type="flex" align="middle" justify="space-around" class="g-mb-4">
            <g-column :xs="24" :sm="16">
                <g-button
                    shape="round"
                    theme="live"
                    type="primary"
                    block
                    size="xlarge"
                    :loading="isLinkLoading"
                    :disabled="isLinkLoading"
                    @click="isDone ? handleClose() : handleContinue()"
                >
                    {{ buttonText }}
                </g-button>
            </g-column>
        </g-row>

        <g-row v-if="isTrolley" class="g-mt-6">
            <g-typography
                tag="p"
                text-align="center"
                color="grey-6"
                v-html="$sanitize(ONBOARDING_STEPS_TROLLEY_NEED_HELP)"
            />
        </g-row>
    </div>
</template>

<script>
    import {
        ONBOARDING_STEPS,
        ONBOARDING_STEPS_TROLLEY,
        ONBOARDING_STEPS_TROLLEY_NEED_HELP
    } from '../../../../../app-v2/constants/payouts';

    export default {
        name: 'OnboardingStep',

        props: {
            title: {
                type: String,
                default: ''
            },
            message: {
                type: String,
                default: ''
            },
            image: {
                type: String,
                default: ''
            },
            isTrolley: {
                type: Boolean,
                default: false
            },
            isDone: {
                type: Boolean,
                default: false
            },
            currentStepId: {
                type: Number,
                default: 0
            },
            isLinkLoading: {
                type: Boolean,
                default: false
            }
        },

        setup(props, { emit }) {
            const onboardingSteps = props.isTrolley ? ONBOARDING_STEPS_TROLLEY : ONBOARDING_STEPS;
            const showStep = props.isTrolley ? props.currentStepId : props.currentStepId - 1;

            let buttonText = 'Continue';
            if (props.isDone) {
                buttonText = 'Done';
            }

            const handleContinue = () => {
                emit('continue');
            };

            const handleClose = () => {
                emit('close');
            };

            return {
                // data
                buttonText,
                onboardingSteps,
                ONBOARDING_STEPS_TROLLEY_NEED_HELP,
                showStep,

                // methods
                handleContinue,
                handleClose
            };
        }
    };
</script>

<style lang="scss" scoped>
    ::v-deep .ant-steps .ant-steps-item-title {
        font-size: 14px;
        line-height: 21px;
        font-weight: 500;
        margin-bottom: 0.5rem;
    }

    ::v-deep .ant-steps .ant-steps-item-description {
        padding-bottom: 1.5rem;
    }

    ::v-deep .theme-live.ant-btn-primary {
        background-color: #787cff !important;
        border: 1px solid #787cff !important;
    }
</style>
